<template lang="html">
<div class="about">
  <div class="about__container">
    <h1 class="about__title">À propos</h1>
    <div class="about__credit about__texts">
      <h2 class="about__subtitle">Crédits</h2>
        <p class="about__production about__text"><span class="about__text--bold">Production : </span>Réunion des musées nationaux - Grand Palais</p>
        <p class="about__project-management about__text"><span class="about__text--bold">Gestion de projet : </span>Léa Ducré - UPIAN</p>
        <p class="about__project-management about__text"><span class="about__text--bold">Conception, direction artistique : </span>Karim Moreau - UPIAN</p>
        <p class="about__project-management about__text"><span class="about__text--bold">Code créatif & développement : </span>Emmanuel Durgoni, Geoffrey Legenty - UPIAN</p>
    </div>
    <div class="about__data-collect about__texts">
      <h2 class="about__subtitle">Protection des données</h2>
      <p class="about__text">Aucune donnée personnelle afférente à l'utilisation du site n'est collectée
        de façon permanente ni transmise à des tiers.</p>
    </div>
    <div class="about__contact about__texts">
      <h2 class="about__subtitle">Contact</h2>
      <p class="about__text about__text--mail">webmaster@rmngp.fr</p>
    </div>
    <ui-button-to-home :goToFilters="false"></ui-button-to-home>
  </div>
  <ui-footer ref="uiFooter"></ui-footer>
</div>
</template>

<script>
import UiFooter from 'components/UI/Footer.vue'
import UiButtonToHome from 'components/UI/ButtonToHome.vue'
import Emitter from 'core/Emitter'
import 'styles/components/about.styl'
export default {
  name: 'about',
  components: {
    UiFooter,
    UiButtonToHome
  },
  mounted () {
    Emitter.emit('SET_MENU_WHITE')
    this.resizeScroll()
    let tl = new TimelineMax()
    this.tweenEnter()
  },
  beforeDestroy () {
    Emitter.emit('SET_MENU_TRANSPARENT')

  },
  methods: {
    resizeScroll () {
      this.offsetHeight = this.$el.offsetHeight
      this.$parent.fakeScroll.style.height = 'auto'
    },
    tweenEnter () {
      let creditEl = this.$el.querySelectorAll('.about__credit')
      let dataColEl = this.$el.querySelectorAll('.about__data-collect')
      let contactEl = this.$el.querySelectorAll('.about__contact')
      let title = this.$el.querySelector('.about__title')
      let buttonToHome = this.$el.querySelector('.button-to-home')
      this.tlEnter = new TimelineMax()
      .staggerFrom([title, creditEl, dataColEl, contactEl, buttonToHome], 1, {
        x: -30,
        autoAlpha: 0,
        ease: Cubic.easeOut
      }, 0.3, '-=1')
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** index.vue?7b9348e6
 **/